SlideView           = require("views/slide")
ScormAttempt        = require "models/scormAttempt"
Device              = require "lib/device"
{ Session, Lesson } = Application.actions()

class SCORMView extends SlideView
  template: require("./template")
  events: ->
    "iostap .exit-btn": "stopSCORM"

  initialize: ->
    super

    Session.get (err, { firstName, lastName, email, name, id }) =>
      studentName = ((firstName || '') + ' ' + (lastName || '')).trim() || name || email || ''
      @scormAttempt = new ScormAttempt("lessonId", false, studentName, id, @options.previousAttempt)
      
    @isLastSlide  = @options.isLastSlide

  processIframeMessage: (event) ->
    if event?.data?.match?("window.SCORMED")
      eval(event.data)

  beforeShow: ->
    position = @options.data.button?.position?.toLowerCase() or "none"
    @setState written.hyphenCase(position), "exit-btn"

    @trigger "ui", { lightbox: @options.data.background or true, fullscreen: true }

    @onResize()

  beforeHide: ->
    @trigger "ui", { lightbox: false, fullscreen: false }

  show: ->
    @stopped = false
    position = @options.data.button?.position?.toLowerCase() or "none"
    @setState written.hyphenCase(position), "exit-btn"

    @listenTo this, "resize", @onResize

    if !@options.notInteractable
      @initSCORM()
      
    window.addEventListener("message", @processIframeMessage , false)

  onRefresh: ->
    @beforeShow()
    super

  onResize: ->
    if @currentState["exit-btn"] is "below"
      button = @findOne(".exit-btn")
      iframe = @findOne(".scorm-object")

      iframe.style.bottom = "#{button.offsetHeight}px"
      iframe.style.height =
        "#{iframe.parentNode.offsetHeight - button.offsetHeight}px"

  stopSCORM: ->
    return if @stopped
    @stopped = true
    window.API?.LMSFinish()
    window.removeEventListener("message", @processIframeMessage , false)
    attemptData = @scormAttempt.attemptData()
    raw = attemptData?["cmi.core.score.raw"]?.value
    tot = attemptData?["cmi.core.score.max"]?.value

    score = if raw and tot
      # use package score
      parseInt(raw) * 1.0 / parseInt(tot)
    else
      # use 100 for success and 0 for not success
      if attemptData?.success then 1 else 0

    Session.get (err, { attempt }) =>
      interaction =
        id:              @options.id
        name:            @options.name
        type:            @options.type
        slideData:       @options.data
        scormData:       attemptData
        attempt:         attempt
        correct:         attemptData?.success
        answerDetails:   []
        metadata:        @options.metadata
        isScormAttempt:  true
        score:           score
        isCompleted:     attemptData?.success
        isRequiredForLessonCompletion: @options.data.isRequiredForLessonCompletion
        configuration:   @options.data?.challenge_configuration

      @lesson.processInteraction(interaction)

      if window.ED_LMS_PREVIEW or window.ED_PUBLIC_PREVIEW
        return
      else if @isLastSlide
        Lesson.complete()
        @exit()
      else
        @next()

  serialize: ->
    data = super
    sandboxedFeatures = [ "allow-scripts", "allow-same-origin", "allow-modals", "allow-popups", "allow-popups-to-escape-sandbox", "allow-forms", "allow-downloads" ]

    data.allowedSandboxedFeatures = sandboxedFeatures.join(" ")
    data

  initSCORMResource: ->
    data     = @serialize()
    resource = data.package
    if !resource or resource is "scorm/scorm.zip"
      return

    @findOne(".scorm-object").src = resource

    window.SCORMED = LMSFinish: (data) =>
      @scormAttempt.processScormPlayerData(data)
      @stopSCORM()

  initSCORM: ->
    scormData  = @scormAttempt.initialData()
    callbacks  = success: (success) => @initSCORMResource() if success
    # Required to conform to the SCORM protocol.
    # It is the way the SCORM package on the iframe will actually find
    # a SCORM API to communicate with
    scormAPI = new ScormAPI("lesson", "LID", scormData, callbacks)
    window.API = scormAPI
    window.API_1484_11 = scormAPI

module.exports = SCORMView
